import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";
import KendaraanServiceMain from "../../../features/masters/kendaraan-service/components/kendaraan-service-main";

const title = "Master Kendaraan & Service";

const KendaraanServiceMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <KendaraanServiceMain />;
};

export default KendaraanServiceMasterPage;
